"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { useCurrentUrl } from "@/hooks/use-current-url.hook";
import { EmailIcon } from "../Icons/components/ShareIcons/EmailIcon.component";
import { LinkedInIcon } from "../Icons/components/ShareIcons/LinkedInIcon.component";
import { MsTeamsIcon } from "../Icons/components/ShareIcons/MsTeamsIcon.component";
import { ShareLink } from "./components/ShareLink.component";
type ShareButtonsProps = {
  readonly title: string;
  readonly className?: string;
  readonly variant: "outline-inverse" | "outline" | "primary" | "secondary";
  readonly position: "top" | "bot";
};
export function ShareButtons(t0) {
  const $ = _c(25);
  const {
    title,
    className,
    variant,
    position
  } = t0;
  const {
    absolute
  } = useCurrentUrl();
  const encodedTitle = encodeURIComponent(title);
  let t1;
  if ($[0] !== className) {
    t1 = clsx(className, "flex gap-1");
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LinkedInIcon className="size-2.5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${position}-li-a`;
  const t4 = `https://www.linkedin.com/shareArticle?url=${absolute}?utm_source=linkedin&utm_content=article_share_linkedin`;
  let t5;
  if ($[3] !== t3 || $[4] !== t4 || $[5] !== title || $[6] !== variant) {
    t5 = <ShareLink icon={t2} label="LinkedIn" position={t3} title={title} url={t4} variant={variant} />;
    $[3] = t3;
    $[4] = t4;
    $[5] = title;
    $[6] = variant;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MsTeamsIcon className="size-3.5 h-full w-full" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = `${position}-mst-a`;
  const t8 = `https://teams.microsoft.com/share?href=${absolute}&msgText=${encodedTitle}&referrer=${absolute}?utm_source=ms_teams&utm_content=article_share_ms_teams`;
  let t9;
  if ($[9] !== t7 || $[10] !== t8 || $[11] !== title || $[12] !== variant) {
    t9 = <ShareLink icon={t6} label="Teams" position={t7} title={title} url={t8} variant={variant} />;
    $[9] = t7;
    $[10] = t8;
    $[11] = title;
    $[12] = variant;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <EmailIcon className="size-2.5" />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = `${position}-mto-a`;
  const t12 = `mailto:?subject=${encodedTitle}&body=${absolute}?utm_source=mail&utm_content=article_share_mail`;
  let t13;
  if ($[15] !== t11 || $[16] !== t12 || $[17] !== title || $[18] !== variant) {
    t13 = <ShareLink icon={t10} label="Email" position={t11} title={title} url={t12} variant={variant} />;
    $[15] = t11;
    $[16] = t12;
    $[17] = title;
    $[18] = variant;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t1 || $[21] !== t13 || $[22] !== t5 || $[23] !== t9) {
    t14 = <div className={t1}>{t5}{t9}{t13}</div>;
    $[20] = t1;
    $[21] = t13;
    $[22] = t5;
    $[23] = t9;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
}